import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import { MuiThemeProvider } from '@material-ui/core/styles';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Autosuggest from 'react-autosuggest';

// Custom Inputs
import CustomDialog from './inputs/CustomDialog'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import InnerBar from './InnerBar';
import MetaBox from './inputs/MetaBox'
import TextInput from './inputs/TextInput'
import FormSelect from './inputs/FormSelect'

import {
  is_logged_on,
  is_validating,
  capitalize,
  theme
} from "../helpers"

 import {
   LocalForm,
   Control,
   actions
} from 'react-redux-form'

import {
  isRequired,
  validateEmailType
} from "../validators"

import {
  get_voucher,
  preferences_index,
  create_voucher,
  update_voucher,
  reset_voucher,
  clear_voucher,
  coupons_select,
  templates_select,
  voucher_autofill,
  voucher_autofill_clear,
} from '../actions'

const mapStateToProps = state => {
  const { voucher, errors, fetching_single, fetched_single, must_redirect } = state.voucher
  return {
    voucher,
    errors,
    fetching_single,
    fetched_single,
    must_redirect,
    current_user: state.auth.current_user.data,
    preferences: state.preference.preferences,
    coupons: state.coupon.select_items,
    templates: state.template.select_items,
    autofill: state.voucher.autofill
  }

}

const mapDispatchToProps = dispatch => {
  return {
    getVoucher: voucher_id => dispatch( get_voucher(voucher_id) ),
    createVoucher: values => dispatch( create_voucher(values) ),
    updateVoucher: (voucher_id, values) => dispatch( update_voucher(voucher_id, values) ),
    getPreferences: () => dispatch( preferences_index() ),
    resetVoucher: () => dispatch( reset_voucher() ),
    clearVoucher: () => dispatch( clear_voucher() ),
    getCoupons: () => dispatch( coupons_select() ),
    getTemplates: () => dispatch( templates_select() ),
    getAutofill: (input) => dispatch( voucher_autofill(input) ),
    clearAutofill: () => dispatch( voucher_autofill_clear() ),
  };
};

class ConnectedVoucherForm extends React.Component {
  state = {
    actionName: '',
    nameValid: true,
    surnameValid: true,
    emailValid: true,

    // DropDowns
    coupon: '',
    couponValid: true,
    template: '',
    templateValid: true,

    autofill: '',
    showSuggestions: true,

    formData: null,
    activate: false, // bind to action
    revoke: false, // bind to action

    showDialog: false,
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  checkValid() {
    this.formDispatch( actions.setDirty('voucher.name') )
    this.formDispatch( actions.setDirty('voucher.surname') )
    this.formDispatch( actions.setDirty('voucher.email') )

    const isValid = this.state.formData.$form.valid
    if (!isValid) {
      window.showSnackbar('error', 'Please fill in all mandatory fields.')
    }
    return isValid
  }

  handleSubmit(inValues) {
    let values = {
      ...inValues
    }
    if (this.state.activate) {
      values={
        ...inValues,
        activate: true,
        revoke: false,
        index: false
      }
    } else if (this.state.revoke) {
      values={
        ...inValues,
        activate: false,
        revoke: true,
        index: false
      }
    }

    if (this.state.actionName === "create") {
      this.props.createVoucher(values)
    } else {
      const { voucher_id } = this.props
      this.props.updateVoucher(voucher_id, values)
    }
  }

  handleUpdate(form) {
    const { name, surname, email } = form
    this.setState({formData: form})

    this.setState({
      nameValid: (name.pristine || name.valid),
      surnameValid: (surname.pristine || surname.valid),
      emailValid: (email.pristine || email.valid),
    })
  }

  resetView() {
    const { actionName } = this.props
    const { clearVoucher, voucher, getVoucher } = this.props
    clearVoucher()
    this.setState({ actionName })
    if ( actionName === 'update') {
      const { voucher_id } = this.props
      if ( voucher.id !== voucher_id ) {
        getVoucher(voucher_id)
      }
    }
  }

  componentWillMount() {
    this.resetView()
    this.props.getCoupons()
    this.props.getTemplates()
  }

  componentWillUpdate(prevProps, prevState) {
    const { actionName, must_redirect } = this.props
    if (this.state.actionName !== actionName ) {
      return this.resetView()
    }
    if (this.props.must_redirect && !prevProps.must_redirect) {
      window.showSnackbar('success', 'Voucher has been saved.')
    }
    if (this.props.actionName === 'update') {
      if ( this.state.coupon === '' && this.props.voucher.coupon_id  ) {
        this.setState({ coupon: this.props.voucher.coupon_id})
        this.formDispatch(actions.change('voucher.coupon_id', this.props.voucher.coupon_id))
      }
    }

    if (must_redirect && this.state.activate) {
      window.showSnackbar('success', 'The voucher status has changed to: Active.')
      this.setState({activate: false})
    } else if (must_redirect && this.state.revoke) {
      window.showSnackbar('success', 'The voucher status has changed to: Revoked.')
      this.setState({revoke: false})
    }
  }

  hideDialog() {
    this.setState({showDialog: false, showRevokeDialog: false})
  }

  handleActivate() {
    this.props.resetVoucher()
    this.setState({activate: true, revoke: false, showDialog: false})
    this.formDispatch(actions.submit('voucher'))
  }

  handleRevoke() {
    this.props.resetVoucher()
    this.setState({activate: false, revoke: true, showRevokeDialog: false})
    this.formDispatch(actions.submit('voucher'))
  }

  handleChangeCoupon(e) {
    const { value } = e.target
    this.formDispatch(actions.change('voucher.coupon_id', value))
    this.setState({coupon: value, couponValid: ( value && value !== '' )})
  }

  handleChangeTemplate(e) {
    const { value } = e.target
    this.formDispatch(actions.change('voucher.template_id', value))
    this.setState({template: value, templateValid: ( value && value !== '' )})
  }

  handleChangeSearchEmail(value) {
    const newValue = (value && (typeof value === "string")) ? value : value.target.value
    this.setState({showSuggestions: true, autofill: newValue})
    if (newValue && newValue.length > 2) {
      this.props.getAutofill(newValue)
    } else {
      this.props.clearAutofill()
    }
  }

  handleFetchSuggestions(event, value) {
    if (value && value.email) {
      this.formDispatch(actions.change('voucher.email', value.email))
      this.formDispatch(actions.change('voucher.name', value.name))
      this.formDispatch(actions.change('voucher.surname', value.surname))
      this.setState({autofill: value.email, showSuggestions:false})
    }
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { actionName, must_redirect, fetching_single } = this.props

    if ( actionName === 'create' && this.props.must_redirect ) {
      return <Redirect to={`/vouchers`} />
    }

    if ( actionName === 'update' && !this.props.voucher.id ) {
      return ''
    }

    const {
      name, surname, email, status, business_name, skill_name, id,
      created_at, updated_at
    } = this.props.voucher
    const { coupons, templates, autofill } = this.props
    const { coupon } = this.state

    let initialState
    if (actionName === "create") {
      initialState = {
        name: '',
        surname: '',
        email: '',
      }
    } else {
      initialState = {
        name,
        surname,
        email,
      }
    }

    const actionButtons = (
      <div className="d-flex">
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center mr-16"
          disabled={(false && !this.state.formValid) || actionName === 'update' || fetching_single}
          onClick={e => {
            e.preventDefault()
            this.setState({activate: false, revoke: false})
            this.checkValid()
            this.formDispatch( actions.submit('voucher'))
          }}>Save</CustomOutlinedButton>
      </div>
    )

    return (
      <MuiThemeProvider theme={theme}>
        <Grid container spacing={24} justify="space-between" className={fetching_single ? 'long_saving' : ''}>

          <Grid item xs={12} md={ actionName === "create" ? 12 : 8} className={actionName !== "create" ? "will-change9" : ''}>
            <div className="d-flex justify-content-between mb-40">
              <Typography className="fw-bold h4">
                {this.props.headTitle || "Voucher"}
              </Typography>

              { actionButtons }

            </div>
          </Grid>

          <Grid item xs={12} md={ actionName === "create" ? 12 : 8} className={actionName !== "create" ? "will-change9" : ''}>
            <LocalForm
              model="voucher"
              className="collection-item"
              initialState={initialState}
              getDispatch={(dispatch) => this.attachDispatch(dispatch)}
              onUpdate={(form) => this.handleUpdate(form)}
              onSubmit = {(values) => this.handleSubmit(values)}
            >

              <Paper use="name" className="mb-24 innerbar">
                <InnerBar text="Coupon & Test Template" />
                <div className="pl-24 pr-24 pt-24 pb-24">

                  <Control.select
                    model="wac"
                    id="voucher-coupon"
                    value={this.state.coupon}
                    label="Select Coupon *"
                    component={FormSelect}
                    required
                    error={!this.state.couponValid}
                    helperText={this.state.couponValid ? '' : 'Coupon is required'}
                    className="w-100 label-pl16"
                    onChange={(e) => this.handleChangeCoupon(e)}
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      }
                    }}

                  >
                  {
                    coupons.filter( c => c.voucherable ).map( coupon => {
                      const dname = `${coupon.name} [${coupon.business_name}]`
                      return <MenuItem key={coupon.id} value={coupon.id}>{dname}</MenuItem>
                    })
                  }
                  </Control.select>

                  <Control.select
                    model="wat"
                    id="voucher-template"
                    value={this.state.template}
                    label="Select Template [Optional]"
                    component={FormSelect}
                    error={!this.state.templateValid}
                    helperText={this.state.templateValid ?
                      "Leave empty to make Voucher available for any Test Template" :
                      this.props.errors.filter( er => /Test/.test(er) ).join(". ") }
                    className="w-100 label-pl16 mt-12"
                    onChange={(e) => this.handleChangeTemplate(e)}
                  >
                    <MenuItem value={undefined} style={{color: 'rgba(0,0,0,0.6)'}}>Usable for all Test Templates</MenuItem>
                    {
                      templates.map( template => {
                        return <MenuItem key={template.id} value={template.id}>{template.name}</MenuItem>
                      })
                    }
                  </Control.select>

                </div>
              </Paper>

              <Paper use="name" className="mb-24 innerbar">
                <InnerBar text="Test Taker Data" />
                <div className="pl-24 pr-24 pt-24 pb-24">
                  <Autosuggest
                    suggestions={autofill}
                    alwaysRenderSuggestions={autofill.length > 0 && this.state.showSuggestions}
                    highlightFirstSuggestion
                    focusInputOnSuggestionClick={false}
                    getSuggestionValue={ suggestion => suggestion }
                    onSuggestionSelected={ (event, {suggestion}) => suggestion }
                    inputProps={{
                      value: this.state.autofill,
                      onChange: (event, {newValue}) => this.handleFetchSuggestions(event, newValue)
                    }}
                    disabled={actionName === 'update'}
                    onSuggestionsFetchRequested={ ({value}) => 'null' }
                    onSuggestionsClearRequested={ () => 'null' }
                    renderSuggestion={ (suggestion, { query, isHighlighted }) =>`${suggestion.email} ${suggestion.display_name}` }
                    renderInputComponent={ props => (
                      <TextInput
                        id="voucher-email"
                        model="voucher.email"
                        placeholder="Email (new user or autocomplete existent)"
                        helperText={this.state.emailValid ? "Enter Email *" : "A valid email is required *"}
                        error={!this.state.emailValid}
                        onChange={event => this.handleChangeSearchEmail(event)}
                        validators={{
                          required: (val) => {
                            return  validateEmailType(val)
                          }
                        }}
                      />
                    )}
                  />

                  <TextInput
                    id="voucher-name"
                    model="voucher.name"
                    required
                    placeholder="Name"
                    helperText={this.state.nameValid ? "Enter Name *" : "Name is required *"}
                    error={!this.state.nameValid}
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      }
                    }}
                  />

                  <TextInput
                    id="voucher-surame"
                    model="voucher.surname"
                    placeholder="Surname"
                    helperText={this.state.surnameValid ? "Enter Surname *" : "Surname is required *"}
                    error={!this.state.surnameValid}
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      }
                    }}
                  />

                </div>
              </Paper>
            </LocalForm>

            <Hidden smDown>
              <div className="d-flex justify-content-end mt-40">
                { actionButtons }
              </div>
            </Hidden>
          </Grid>

          { actionName === "update" && (
            <Grid item xs={12} md={4} className="will-change3">

              <Paper>
                <div className="bg-white">
                  <div className="pt-24 pb-24 pr-24 pl-24">
                    <div className="mb-12 c-black087 body2">
                      <span className="d-inline-block fw-bold min-width-100">Status:</span>{capitalize(status)}
                    </div>

                    <MetaBox
                      title="Business"
                      value={business_name}
                    />
                    {
                      skill_name && (<MetaBox
                        title="Skill"
                        value={skill_name}
                      />)
                    }

                    <MetaBox
                      title="Created on"
                      value={new Date(created_at).toLocaleString()}
                    />
                    { updated_at && (<MetaBox
                      title="Modified on"
                      value={new Date(updated_at).toLocaleString()}
                    />)}
                  </div>
                </div>

                <Divider className="bg-divider" />

                <div className="bg-white">
                  <div className="pt-24 pb-24 pr-24 pl-24">
                  <div className="fw-bold body2">Actions:</div>
                    {
                        (status !== 'active' ) ? (
                          <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                              e.preventDefault()
                              if (this.checkValid()) {
                                this.setState({showDialog:true})
                              }
                          }}>Activate Voucher</Link>
                        ) : (
                          <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=> {
                            e.preventDefault()
                            if (this.checkValid()) {
                              this.setState({showRevokeDialog:true})
                            }
                          }}>Revoke Voucher</Link>
                        )
                      }

                  </div>
                </div>
              </Paper>

              <CustomDialog
                id={`active-dialog`}
                qid={id}
                isopen={this.state.showDialog}
                handleClose={this.hideDialog.bind(this)}
                handleAccept={this.handleActivate.bind(this)}
                fullScreen = {false}
                title={`Activate Voucher?`}
              >
                Do you want to save changes and activate this voucher?
              </CustomDialog>
              <CustomDialog
                id={`revoke-dialog`}
                qid={id}
                isopen={this.state.showRevokeDialog}
                handleClose={this.hideDialog.bind(this)}
                handleAccept={this.handleRevoke.bind(this)}
                fullScreen = {false}
                title={`Revoke Voucher?`}
              >
                Do you want to save changes and revoke this voucher?
              </CustomDialog>
            </Grid>
          )}
        </Grid>

      </MuiThemeProvider>
    )
  }
}

const VoucherForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedVoucherForm)
export default VoucherForm



// WEBPACK FOOTER //
// ./src/js/components/VoucherForm.js